/**
 * Bağlı test ortamı hesapları paneli (ADR 0092): gemi uygulaması ve web ofis giriş ekranı.
 */

export const testAccountsEn = {
  title: 'Test accounts',
  badge: 'TEST',
  subtitle: '{{company}} · closed test environment',
  passwordLabel: 'Shared password:',
  use: 'Use',
  useAccount: 'Use {{name}} ({{role}})',
  office: 'Office',
  count: '{{count}} accounts',
  signInOffice: 'sign in at the office web app',
  signInOnBoard: 'sign in on board',
  hint: 'Pick an account and press Use: the form is filled, then sign in. To switch user, sign out and pick another account.',
};

export const testAccountsTr: typeof testAccountsEn = {
  title: 'Test hesapları',
  badge: 'TEST',
  subtitle: '{{company}} · kapalı test ortamı',
  passwordLabel: 'Ortak parola:',
  use: 'Kullan',
  useAccount: '{{name}} ({{role}}) ile gir',
  office: 'Ofis',
  count: '{{count}} hesap',
  signInOffice: 'web ofiste girilir',
  signInOnBoard: 'gemide girilir',
  hint: 'Bir hesap seçip Kullan’a basın: form dolar, sonra giriş yapın. Kullanıcı değiştirmek için çıkış yapıp başka hesap seçin.',
};
